import React from 'react';
import { useAuthorizationGate } from './authorization-gate.hooks';

export type AuthorizationGateProps = {
  any?: string[];
  all?: string[];
  permission?: string;
};

const AuthorizationGate = ({
  any,
  all,
  permission,
  children,
}: React.PropsWithChildren<AuthorizationGateProps>) => {
  const authorized = useAuthorizationGate(any, all, permission);

  return authorized ? <>{children}</> : null;
};

export default AuthorizationGate;
